import React from 'react';
import { StaticQuery, graphql } from 'gatsby';

// Create a GraphQL query for the comment list.
const dictionary = require("../dic/dic.json");

// Main component class.
class CommentList extends React.Component {
	// Render stuff.
	render() {
		const postId = this.props.postId;
    const comments = this.props.comments;
    if (comments.nodes.length < 1) return (<div><span className="titlebar">{comments.nodes.length} {dictionary[this.props.lang].comment}</span>{dictionary[this.props.lang].post_comments}</div>);
		return (
				<div className="comment-list">
					<span className="titlebar">{comments.nodes.length} {dictionary[this.props.lang].comment}</span>
					<ul className="commentwrap">
						{comments.nodes.map((comment) => (
							<li className="comment even thread-even depth-1 comment" id={"comment-" + comment.databaseId}>
								<div className="contents">
									<div className="commentinfo">
										<div className="profile">
											<img src="/files/user/avatar/default.jpg" className="gravatar" alt={comment.author.node.name}/>
										</div>
										<div className="meta">
											<span className="meta-autor">{comment.author.node.name}</span>
											<span className="meta-fecha">{comment.date}</span>
										</div>
										<div className="buttons">
											{/*<a rel="nofollow" style="cursor: pointer;" className="comment-reply-link respcomment" data-idcomment="8268" data-parent="8268" aria-label="Responder a Pedro">Responder</a>*/}
											<span className="isauthor"><span className="long">Autor</span><i className="fa fa-user"></i></span>
										</div>
									</div>
									<div className="body" dangerouslySetInnerHTML={{ __html: comment.content }} />
								</div>
							</li>
						))}
					</ul>
				</div>
 		);
	}
}


export default CommentList;
